import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system/components")({
  component: () => <Navigate to="/admin/design-system/components" />,
});
